import { render, staticRenderFns } from "./kits.vue?vue&type=template&id=16bda1f9"
import script from "./kits.vue?vue&type=script&lang=js"
export * from "./kits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports